import stopImmediatePropagation
  from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import resize from '@mailobj-browser/front/js/events/types/resize.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import append from '@mailobj-browser/front/js/tree/append.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import replaceChildren from '@mailobj-browser/front/js/tree/replaceChildren.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import * as utilities from '#utilities/js/styles.js'
import * as sharedClasses from '#utilities/js/ea/sharedClasses.js'

const add = (from, to) => {
  const { childNodes: [...nodes] } = from

  append(to, nodes)

  for (const node of nodes) {
    queueMicrotask(async () => {
      await removed(node)
      append(from, node)
    })
  }
}

const onButtonClick = object(listener, {
  type: click,
  passive,
  hooks: array([
    stopImmediatePropagation
  ]),
  task: (button) => {
    const { ownerDocument } = button
    const { defaultView } = ownerDocument
    const bar = one('#id_menu_bar', ownerDocument)
    const mobile = one('#id_menu_barm', ownerDocument)
    const launcher = one('#id_menu_barl', ownerDocument) ?? mobile
    const menus = one('#div_MENUS', ownerDocument)
    const infos = one('#div_MENU_HINFOS', ownerDocument)
    const heads = one('#div_MENU_HEAD', ownerDocument)
    const util = one('#div_UTIL', ownerDocument)

    if (!bar || !mobile) {
      return
    }

    add(menus, mobile)

    if (infos) {
      add(infos, launcher)
    }

    if (heads) {
      add(heads, launcher)
    }

    onBarClick.listen(bar)
    onResize.listen(defaultView)
    append(util, bar)
    bar.classList.remove(utilities.modifiers.display.none)
    bar.classList.remove(utilities.modifiers.visibility.hidden)
    globals.ea_elt_display(bar, true, true)
    sharedClasses.add(bar, utilities.modifiers.overflow.hidden)
  }
})

const onBarClick = object(listener, {
  type: click,
  passive,
  hooks: array([
    stopImmediatePropagation
  ]),
  task: (bar) => {
    const { ownerDocument } = bar
    const mobile = one('#id_menu_barm', ownerDocument)
    const launcher = one('#id_menu_barl', ownerDocument) ?? mobile

    replaceChildren(mobile)
    replaceChildren(launcher)
    bar.classList.add(utilities.modifiers.display.none)
    bar.classList.add(utilities.modifiers.visibility.hidden)
    globals.ea_elt_display(bar, false, false)
    sharedClasses.remove(bar, utilities.modifiers.overflow.hidden)
  }
})

const onResize = object(listener, {
  type: resize,
  once,
  passive,
  task: (window) => {
    const { document, requestAnimationFrame } = window

    requestAnimationFrame(() => {
      const bar = one('#id_menu_bar', document)

      if (!bar) {
        return
      }

      const burger = one('#id_menu_click', document)
      const launcherBar = getComputedStyle(burger).getPropertyValue('--ea_generics_launcher_bar')

      if (launcherBar === 'true') {
        onBarClick.task(bar)

        return
      }

      onResize.listen(window)
    })
  }
})

export default opener => {
  onButtonClick.listen(opener)
}
